module.exports = __webpack_public_path__ + "img/close.4bdedc95.svg";